(() => {

    function sanitizeEntryPoint() {
        try {
            const origin = window.location.origin;
            const pathname = window.location.pathname.replace(/\/$/, "") || "/";
            let value = origin + pathname;

            const wellbeingMarker = "/your-wellbeing";
            if (value.includes(wellbeingMarker)) {
                value = value.split(wellbeingMarker)[0];
            }

            return value;
        } catch {
            return "";
        }
    }

    function setEntryPoint() {
		try {
			if (!sessionStorage.getItem("entryPoint")) {
				const entryPoint = sanitizeEntryPoint();
				if (entryPoint) {
					sessionStorage.setItem("entryPoint", entryPoint);
				}
			}
		} catch {
			// ignore storage errors
		}
	}

    function clearEntryPoint() {
        try {
            sessionStorage.removeItem("entryPoint");
        } catch {
            // ignore
        }
    }

    function hasRequiredConsentFromEvent(e) {
        return (
            e &&
            Array.isArray(e.detail) &&
            e.detail.includes("C0002") &&
            e.detail.includes("C0004")
        );
    }

    function hasRequiredConsentFromCookie() {
        try {
            const cookie = document.cookie
                .split("; ")
                .find(c => c.startsWith("OptanonConsent="));

            if (!cookie) return false;

            const decoded = decodeURIComponent(cookie);
            const match = decoded.match(/groups=([^&]+)/);
            if (!match) return false;

            const groups = match[1];
            return groups.includes("C0002:1") && groups.includes("C0004:1");

        } catch {
            return false;
        }
    }

    function handleConsentChange(e) {
        const hasConsent =
            hasRequiredConsentFromEvent(e) ||
            hasRequiredConsentFromCookie(); // fallback

        if (hasConsent) {
            setEntryPoint();
        } else {
            clearEntryPoint();
        }
    }

    function init() {
        if (!window.OneTrust || !window.OneTrust.OnConsentChanged) {
            // fallback retry if OneTrust loads late
            setTimeout(init, 300);
            return;
        }

        window.OneTrust.OnConsentChanged(handleConsentChange);
        handleConsentChange();
    }

    init();

})();